import * as Analytics from "expo-firebase-analytics";

const logAnalytics = async (titre, message) => {
  await Analytics.logEvent(titre, { message });
};

export default logAnalytics;
